import React from "react";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import PropTypes from "prop-types";
import CitationFormatter from "./citation-formatter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

const Citation = ({ doi }) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}
    >
      <CitationFormatter doi={doi}></CitationFormatter>
    </PersistQueryClientProvider>
  );
};

Citation.propTypes = {
  doi: PropTypes.string,
};

export default Citation;
